(function () {
    'use strict';

    angular.module('app.xmlModule', [
        // Angular modules 
        'ngRoute'

        // Custom modules 

        // 3rd Party Modules

    ]);
})();